import React from 'react';
import { observer } from 'mobx-react-lite';

import { timeTo12HourFormat } from '../../../lib/utils/Convertor';
import { Step } from '../../../app/entities/step';

import { DayStartStripProps } from './day-start-strip';
import { InlineTimeSelector } from './InlineTimeSelector';
import { formatDate } from '../../../lib/utils/DateHelper';
import { dateShort } from '../../../assets/contants/dates-fns';

import styles from './day-start-strip.mobile.module.scss';
export const MobileDayStartStrip: React.FC<DayStartStripProps> = observer(({ strip }) => {
  const { dod, stepId } = strip.data || {};

  const shootingDay = Step.getOne(stepId)!;
  if (!shootingDay) return null;

  const formattedDate = shootingDay?.dueDate ? formatDate(shootingDay.dueDate, dateShort) : '';

  return (
    <div className={styles['container']}>
      <div className={styles['day-name']}>
        (#{dod}) {shootingDay.name}
      </div>

      {shootingDay.info?.generalCallTime && (
        <div className={styles['time-wrapper']}>
          <InlineTimeSelector
            backgroundVisible
            time={timeTo12HourFormat(shootingDay.info.generalCallTime)}
            style={{ margin: '0' }}
            onChange={(time) => {
              shootingDay.update({
                info: {
                  generalCallTime: {
                    hour: time.hour,
                    minute: time.minute,
                  },
                },
              });
            }}
          />
        </div>
      )}

      {formattedDate && <div className={styles['date-container']}>{formattedDate}</div>}
    </div>
  );
});
